// API Configuration
// Uses relative URL for custom domains (epp.adm.br, etc.)
// Uses environment variable for preview domains (*.emergentagent.com) and localhost

export const getApiUrl = () => {
  const hostname = window.location.hostname;
  
  // For localhost and emergentagent.com preview domains, use the env variable
  if (hostname === 'localhost' || hostname.includes('emergentagent.com')) {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  // For custom domains (e.g., epp.adm.br), use relative URL (same origin)
  return '';
};

export const API_URL = getApiUrl();
